import { ref } from "vue";

export type RoomValidationNotice = "invalid" | "unavailable" | null;

// An invalid QR is reported once on the Compendium, never persisted with the
// guest profile or placed in the URL.
export const roomValidationNotice = ref<RoomValidationNotice>(null);

export function showRoomValidationNotice(
  reason: Exclude<RoomValidationNotice, null>,
) {
  roomValidationNotice.value = reason;
}

export function dismissRoomValidationNotice() {
  roomValidationNotice.value = null;
}
